import { createLucideIcon } from "lucide-react";

export const MagicWand = createLucideIcon(
    "magic-wand",
    [
        [
            "path",
            {
                d: "M11.1669 2.13627C11.1669 1.76808 10.8684 1.4696 10.5002 1.4696C10.1321 1.4696 9.83358 1.76808 9.83358 2.13627V4.13627C9.83358 4.50446 10.1321 4.80294 10.5002 4.80294C10.8684 4.80294 11.1669 4.50446 11.1669 4.13627V2.13627Z",
                key: "1bg028",
            },
        ],
        [
            "path",
            {
                d: "M11.1669 9.4696C11.1669 9.10141 10.8684 8.80294 10.5002 8.80294C10.1321 8.80294 9.83358 9.10141 9.83358 9.4696V11.4696C9.83358 11.8378 10.1321 12.1363 10.5002 12.1363C10.8684 12.1363 11.1669 11.8378 11.1669 11.4696V9.4696Z",
                key: "1ri51q",
            },
        ],
        [
            "path",
            {
                d: "M12.8573 8.21715C12.5969 7.9568 12.1748 7.9568 11.9145 8.21715C11.6541 8.4775 11.6541 8.89961 11.9145 9.15996L13.3287 10.5742C13.589 10.8345 14.0111 10.8345 14.2715 10.5742C14.5318 10.3138 14.5318 9.89171 14.2715 9.63136L12.8573 8.21715Z",
                key: "jz6p48",
            },
        ],
        [
            "path",
            {
                d: "M13.1669 6.13627C12.7987 6.13627 12.5002 6.43475 12.5002 6.80294C12.5002 7.17113 12.7987 7.4696 13.1669 7.4696H15.1669C15.5351 7.4696 15.8336 7.17113 15.8336 6.80294C15.8336 6.43475 15.5351 6.13627 15.1669 6.13627H13.1669Z",
                key: "1tkp9e",
            },
        ],
        [
            "path",
            {
                d: "M14.2715 3.97451C14.5318 3.71416 14.5318 3.29205 14.2715 3.0317C14.0111 2.77135 13.589 2.77135 13.3287 3.0317L11.9145 4.44592C11.6541 4.70626 11.6541 5.12837 11.9145 5.38872C12.1748 5.64907 12.5969 5.64907 12.8573 5.38872L14.2715 3.97451Z",
                key: "6ulg70",
            },
        ],
        [
            "path",
            {
                d: "M5.83358 6.13627C5.46539 6.13627 5.16691 6.43475 5.16691 6.80294C5.16691 7.17113 5.46539 7.4696 5.83358 7.4696H7.83358C8.20177 7.4696 8.50024 7.17113 8.50024 6.80294C8.50024 6.43475 8.20177 6.13627 7.83358 6.13627H5.83358Z",
                key: "3940xc",
            },
        ],
        [
            "path",
            {
                d: "M7.66751 10.5784L2.81971 15.4262C2.55936 15.6866 2.13725 15.6866 1.8769 15.4262C1.61655 15.1659 1.61655 14.7438 1.8769 14.4834L9.89078 6.46955C10.1511 6.2092 10.5732 6.2092 10.8336 6.46955C11.0939 6.7299 11.0939 7.15201 10.8336 7.41236L9.09033 9.15562C9.0889 9.15707 9.08747 9.15852 9.08603 9.15996L7.67182 10.5742C7.67039 10.5756 7.66895 10.577 7.66751 10.5784Z",
                key: "1bqzns",
            },
        ],
        [
            "path",
            {
                d: "M7.67182 3.0317C7.41147 2.77135 6.98936 2.77135 6.72901 3.0317C6.46866 3.29205 6.46866 3.71416 6.72901 3.97451L8.14322 5.38872C8.40357 5.64907 8.82568 5.64907 9.08603 5.38872C9.34638 5.12837 9.34638 4.70626 9.08603 4.44592L7.67182 3.0317Z",
                key: "1d5qkl",
            },
        ],
    ],
);
